import FourOhFour from './pages/FourOhFour.vue'

import Projects from './projects/Projects.vue'
import ProjectsMain from './projects/ProjectsMain.vue'
import Project from './projects/Project/Project.vue'
import ProjectMain from './projects/Project/ProjectMain.vue'
import ProjectStorytellers from './projects/Project/ProjectStorytellers.vue'
import ProjectHero from './projects/Project/ProjectHero.vue'

import Page from './layouts/Page.vue'

import Competitions from './competitions/Competitions.vue'
import CompetitionsMain from './competitions/CompetitionsMain.vue'
import Competition from './competitions/Competition/Competition.vue'
import CompetitionPage_Main from './competitions/Competition/CompetitionPage_Main.vue'
import CompetitionPage_Rules from './competitions/Competition/CompetitionPage_Rules.vue'
import CompetitionPage_Enter from './competitions/Competition/CompetitionPage_Enter.vue'
import CompetitionPage_Entries from './competitions/Competition/CompetitionPage_Entries.vue'
import CompetitionPage_Entry from './competitions/Competition/CompetitionPage_Entry.vue'
import CompetitionPage_Winners from './competitions/Competition/CompetitionPage_Winners.vue'

import Article from './articles/Article.vue'
import Video from './videos/Video.vue'
import PhotoAlbum from './photos/PhotoAlbum.vue'

import PeoplePagePerson from './layouts/PeoplePagePerson.vue'

export const routes = [
    {
        path: '/',
        component: Page,
        meta: { hero: true }
    },

    {
        path: '/:pathMatch*/article/:articleId',
        component: Article
    },

    {
        path: '/:pathMatch*/videos/view/:videoId',
        component: Video
    },

    {
        path: '/:pathMatch*/photos/view/:albumId',
        component: PhotoAlbum
    },

    {
        path: '/:pathMatch*/person/:personId',
        component: PeoplePagePerson
    },


    {
        path: '/programs/projects/view/:id',
        component: Project,
        meta: { hero: true },
        children: [
            {
                path: '',
                component: ProjectMain,
                meta: { hero: true },
                props: true
            },
            {
                path: 'hero',
                component: ProjectHero,
                meta: { hero: true },
                props: true
            },
            {
                path: 'storytellers',
                component: ProjectStorytellers,
                meta: { hero: true },
                props: true
            }
        ]
    },
    {
        path: '/programs/projects',
        component: Projects,
        meta: {},
        children: [
            {
                path: '',
                component: ProjectsMain,
                meta: { hero: true },
                props: true
            },
            {
                path: 'about',
                component: Page,
                meta: { hero: true },
                props: true
            },
            {
                path: 'start',
                component: Page,
                meta: { hero: true },
                props: true
            }
        ]
    },
    {
        path: '/competitions',
        component: CompetitionsMain,
        meta: { hero: true }
    },
    {
        path: '/competitions/:id',
        meta: { hero: true },
        component: Competition,
        props: true,
        children: [
            {
                path: '',
                component: CompetitionPage_Main,
                meta: { hero: true },
                props: true
            },
            {
                path: 'rules',
                component: CompetitionPage_Rules,
                meta: { hero: true },
                props: true
            },
            {
                path: 'enter',
                component: CompetitionPage_Enter,
                meta: { hero: true },
                props: true
            },
            {
                path: 'finalists',
                component: CompetitionPage_Entries,
                meta: { hero: true },
                props: true
            },
            {
                path: 'finalists/:year',
                component: CompetitionPage_Entries,
                meta: { hero: true },
                props: true
            },
            {
                path: 'winners',
                meta: { filter: "winners", hero: true },
                component: CompetitionPage_Winners,
                props: true
            },
            {
                path: 'winners/:year',
                meta: { filter: "winners", hero: true },
                component: CompetitionPage_Winners,
                props: true
            },
            {
                path: 'entry/:entryId',
                component: CompetitionPage_Entry,
                props: true
            }
        ]
    },
    {
        path: '/404',
        redirect: '/'
    },
    {
        path: '/:pathMatch(.*)*',
        component: Page
    }
]
